import { compose } from 'recompose'
import { withRootDir } from 'src/composables'

const PreviewContainer = compose(withRootDir)

export default PreviewContainer
